import { initializeApp } from "firebase/app";
import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendEmailVerification,
    sendPasswordResetEmail,
    signOut,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAW08pcZtry6LEBbK2KDm-9N_Dkg7KXGAI",
    authDomain: "audo-89e3d.firebaseapp.com",
    projectId: "audo-89e3d",
    storageBucket: "audo-89e3d.firebasestorage.app",
    messagingSenderId: "898618354643",
    appId: "1:898618354643:web:ed1fcbed702bbe0627dd26",
    measurementId: "G-W96S6QQM2G",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendEmailVerification,
    sendPasswordResetEmail,
    signOut,
};
